import Bluesky from '@node-core/ui-components/Icons/Social/Bluesky';
import Discord from '@node-core/ui-components/Icons/Social/Discord';
import GitHub from '@node-core/ui-components/Icons/Social/GitHub';
import LinkedIn from '@node-core/ui-components/Icons/Social/LinkedIn';
import Mastodon from '@node-core/ui-components/Icons/Social/Mastodon';
import Slack from '@node-core/ui-components/Icons/Social/Slack';
import X from '@node-core/ui-components/Icons/Social/X';

export { Bluesky, Discord, GitHub, LinkedIn, Mastodon, Slack, X };
